import { Injectable, NgZone, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

declare global {
  interface Window {
    api: {
      startUpdate: () => void;
      onUpdateProgress: (callback: (percent: number) => void) => void;
      onUpdateStatus: (callback: (status: string) => void) => void;
      checkForUpdate: () => Promise<boolean>;
      splashDone: () => void;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();

  hasUpdate = signal(false);

  constructor(private zone: NgZone) {
    // Subscribe to preload IPC events
    if (window.api?.onUpdateProgress) {
      window.api.onUpdateProgress((percent) => {
        // Use NgZone to trigger Angular change detection
        this.zone.run(() => {
          this.hasUpdate.set(true);
          this.progressSubject.next(percent);
        });
      });
    }

    if (window.api?.onUpdateStatus) {
      window.api.onUpdateStatus((status) => {
        this.zone.run(() => {
          this.hasUpdate.set(false);
          this.loadMainApp();
        });
      });
    }
  }

  async checkUpdateAndStart() {
    const updateAvailable = await window.api.checkForUpdate();
    this.hasUpdate.set(updateAvailable);
    if (updateAvailable) {
      // Start the update.
      this.startUpdate();
    } else {
      // No update: hide splash after 5 seconds
      setTimeout(() => this.loadMainApp(), 5000);
    }
  }

  startUpdate() {
    window.api?.startUpdate();
  }

  private loadMainApp() {
    if (window.api?.splashDone) {
      window.api.splashDone();
    }
  }
}
